import React, { FunctionComponent, PropsWithChildren } from 'react';
import IPageTitleProps from 'src/models/components/IPageTitle';


const PageTitle: FunctionComponent<IPageTitleProps> = (props: PropsWithChildren<IPageTitleProps>) => {
    return <p className='page-title'>{props.title}</p>
};

export default PageTitle;
